export const DOCKER_IMAGE_PROPERTY_NAME = 'docker-image'
export const DOCKERFILE_SOURCE_PROPERTY_NAME = 'dockerfile-source'
export const DOCKERFILE_PATH_PROPERTY_NAME = 'dockerfile-path'
export const LABEL = 'Run in Docker'
export const DESCRIPTION =
  'Run in a Docker container if you need software not available on the agent'
